import React from "react";
import Navbar from "../Components/Navbar";
import MissionPage1 from "../Components/MissionPage1";
import MissionPage2 from "../Components/MissionPage2";
import MissionPage3 from "../Components/MissionPage3";
import Footer from "../Components/Footer"
import '../Styles/AboutMission.scss';
import {Helmet} from "react-helmet";

function AboutMission() {
   return (
      <div>
         <Helmet>
            <title>Mission - Camp Connect</title>
         </Helmet>
         <div className="missionNav">
            <Navbar/>
         </div>
         <MissionPage1/>
         <MissionPage2/>
         <MissionPage3/>
         <Footer/>

      </div>
   )
};

export default AboutMission;
